// extracted by mini-css-extract-plugin
export var wordContainer = "_ny-0";